<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  (onHide)="close()"
  [modal]="true"
  dismissableMask="true"
  closeOnEscape="true"
  position="center"
  focusOnShow="false"
  [draggable]="draggable()"
  [maskStyle]="{ 'backdrop-filter': 'none' }"
>
  <ng-template #header>
    <div class="tar-dialog__header">
      <h3>{{ title() | translate }}</h3>
    </div>
  </ng-template>
  <ng-template #closeicon>
    <i class="ph ph-bold ph-x"></i>
  </ng-template>
  @if (description()) {
    <div class="tar-dialog__body">
      <p>{{ description() | translate: (descriptionParams() || {}) }}</p>
    </div>
  }
  <ng-template #footer>
    <div class="tar-dialog__footer">
      @for (action of actions(); track action) {
        <tar-icon-button
          (click)="action.action()"
          [type]="action.type"
          [icon]="action.icon"
          [label]="action.label | translate"
          [styleClass]="action.styleClass"
          iconPos="right"
        >
        </tar-icon-button>
      }
    </div>
  </ng-template>
</p-dialog>
